import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startingCash", "actualCash", "expectedDisplay", "actualDisplay", "varianceDisplay", "notes", "submitButton", "successMessage", "successDetail"]
  static values = { url: String, cashTotal: Number }

  connect() {
    this.calculate()
  }

  calculate() {
    const startingCents = Math.round(parseFloat(this.startingCashTarget.value || "0") * 100) || 0
    const actualCents = Math.round(parseFloat(this.actualCashTarget.value || "0") * 100) || 0
    const expectedCents = startingCents + this.cashTotalValue

    this.expectedDisplayTarget.textContent = `$${(expectedCents / 100).toFixed(2)}`
    this.actualDisplayTarget.textContent = `$${(actualCents / 100).toFixed(2)}`

    const variance = actualCents - expectedCents
    const absVariance = Math.abs(variance)
    const sign = variance > 0 ? "+" : variance < 0 ? "-" : ""
    this.varianceDisplayTarget.textContent = `${sign}$${(absVariance / 100).toFixed(2)}`

    if (variance === 0) {
      this.varianceDisplayTarget.className = "text-emerald-400"
    } else if (Math.abs(variance) <= 100) {
      this.varianceDisplayTarget.className = "text-amber-400"
    } else {
      this.varianceDisplayTarget.className = "text-red-400"
    }
  }

  async submit() {
    const startingCents = Math.round(parseFloat(this.startingCashTarget.value || "0") * 100) || 0
    const actualCents = Math.round(parseFloat(this.actualCashTarget.value || "0") * 100) || 0
    const notes = this.notesTarget.value.trim()
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = "Closing..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          date: new URLSearchParams(window.location.search).get("date") || new Date().toISOString().split("T")[0],
          actual_cash_cents: actualCents,
          starting_cash_cents: startingCents,
          notes: notes || null
        })
      })

      const data = await response.json()

      if (data.success) {
        const rec = data.reconciliation
        const variance = rec.variance_cents
        const absVar = Math.abs(variance)
        const varSign = variance > 0 ? "+" : variance < 0 ? "-" : ""
        let detail = variance === 0
          ? "Drawer balanced perfectly."
          : `Variance: ${varSign}$${(absVar / 100).toFixed(2)}`

        this.successMessageTarget.classList.remove("hidden")
        this.successDetailTarget.textContent = detail
        this.submitButtonTarget.textContent = "Day Closed"
      } else {
        alert(data.error || "Failed to close day")
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.textContent = "Close Day"
      }
    } catch (err) {
      alert("Network error — please try again")
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.textContent = "Close Day"
    }
  }
}
